import { render, staticRenderFns } from "./TextRedactor.vue?vue&type=template&id=43d1458b&scoped=true&"
import script from "./TextRedactor.vue?vue&type=script&lang=js&"
export * from "./TextRedactor.vue?vue&type=script&lang=js&"
import style0 from "./TextRedactor.vue?vue&type=style&index=0&id=43d1458b&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "43d1458b",
  null
  
)

export default component.exports